module.exports = __webpack_public_path__ + "static/media/bannerImage.8e30241d.jpg";